import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const partnerModalFormSchema = z.object({
  name: z.string().min(1, t('pages.partners.partners_section.components.partner_create_modal.schema.required')),
  file: z
    .any()
    .refine(file => !!file, t('pages.partners.partners_section.components.partner_create_modal.schema.required_image'))
    .refine(
      file => file && file.size <= 2 * 1024 * 1024,
      t('pages.partners.partners_section.components.partner_create_modal.schema.required_image_size'),
    )
    .refine(
      file => file && ACCEPTED_IMAGE_TYPES.includes(file.type),
      t('pages.partners.partners_section.components.partner_create_modal.schema.required_file'),
    ),
});

export type PartnerModalFormData = z.infer<typeof partnerModalFormSchema>;
